<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="ChangeAddress"
        @select="select"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.ChangeAddressPreview.open(0,1)">新建</el-button>
        <el-button type="primary" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <vm-search label="登记日期">
          <div class="block">
            <el-date-picker
                v-model="filter.createTimeBegin"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.createTimeEnd"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model.trim="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="工作联系单号">
          <el-input v-model.trim="filter.contactOrder" clearable/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model.trim="filter.factoryNo" clearable/>
        </vm-search>
        <vm-search label="销售员">
          <el-input v-model.trim="filter.salesPersonName" clearable/>
        </vm-search>
        <vm-search label="状态">
          <el-select v-model.trim="filter.status" clearable>
            <el-option label="草稿" :value="0"/>
            <el-option label="结单" :value="1"/>
          </el-select>
        </vm-search>
        <vm-search label="大小包装">
          <el-select v-model.trim="filter.maxMinPack" clearable>
            <el-option label="大包装" :value="'大包装'"/>
            <el-option label="小包装" :value="'小包装'"/>
          </el-select>
        </vm-search>
        <vm-search label="发运状态">
          <el-select v-model.trim="filter.completeStatus" clearable>
            <el-option label="已发运" :value="'已发运'"/>
            <el-option label="未发运" :value="'未发运'"/>
          </el-select>
        </vm-search>
      </template>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column align="center" prop="createTime" label="创建时间" width="200"/>
      <el-table-column align="center" prop="employeeName" label="创建人" width="80"/>
      <el-table-column align="center" prop="salesArea" label="销售区域" width="80"/>
      <el-table-column align="center" prop="salesPersonName" label="销售员" width="80"/>
      <el-table-column align="center" prop="customerName" label="客户名称" width="200" show-overflow-tooltip/>
      <el-table-column align="center" prop="contactOrder" label="工作联系单号" width="100"/>
      <el-table-column align="center" prop="maxMinPack" label="大小包装" width="80"/>
      <el-table-column align="center" prop="trackCompany" label="快递公司" width="80"/>
      <el-table-column align="center" prop="trackType" label="物流方式" width="80"/>
      <el-table-column
          align="center"
          prop="oldAddress"
          label="原地址"
          width="200"
          show-overflow-tooltip/>
      <el-table-column align="center" prop="oldPrice" label="原地址价格" width="100"/>
      <el-table-column
          align="center"
          prop="newAddress"
          label="更改后地址"
          width="200"
          show-overflow-tooltip/>
      <el-table-column align="center" prop="newPrice" label="更改后价格" width="100"/>
      <el-table-column align="center" prop="payedPrice" label="已收费用" width="100"/>
      <el-table-column align="center" prop="restPrice" label="需要补的费用" width="100"/>
      <el-table-column align="center" prop="factoryNo" label="出厂编号" width="100"/>
      <el-table-column align="center" prop="invoiceNo" label="发货单号" width="100"/>
      <el-table-column
          align="center"
          prop="trackingNumber"
          label="快递单号"
          width="150"
          show-overflow-tooltip/>
      <el-table-column align="center" prop="weight" label="重量" width="100"/>
      <el-table-column
          label="操作"
          align="center"
          width="240px"
          fixed="right">
        <template slot-scope="scope">
          <el-button
              type="primary"
              :disabled="scope.row.status === 1"
              @click="$refs.ChangeAddressPreview.open(scope.row.masterId,1)">
            编辑
          </el-button>
          <el-button type="danger" :disabled="scope.row.status === 1" @click="oneDelete(scope.row)">整单删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <change-address-preview ref="ChangeAddressPreview" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ChangeAddressPreview from "@/views/warehouse/ChangeAddress/ChangeAddressPreview";

  export default {
    name: "ChangeAddressList",
    components: {VmTable, VmSearch, ChangeAddressPreview},
    data() {
      return {
        completeAuth: this.$auth(398),
        filter: {
          customerName: "",
          contactOrder: "",
          factoryNo: "",
          salesPersonName: "",
          createTimeBegin: "",
          createTimeEnd: "",
          employeeName: "",
          status: 0,
          maxMinPack: "",
          completeStatus:"",
        },
        idList: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      select(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },

      getSalesOrder(row) {
        console.log(row);
        this.$router.push({
          path: "/salesOrder",
          query: {
            billType: 1,
            billId: row.pkid,
            $tabName: row.salesOrderNO,
          },
        });
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "ChangeAddress/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      oneDelete(row) {
        this.$http.delete("basic", "ChangeAddress", row.masterId)
          .then(() => {
            this.$message.success("删除成功");
          }).catch(() => {
            this.$message.error("删除失败");
          });
        this.getList(1);
      },
    },
  };
</script>

<style scoped>

</style>
